module.exports = __webpack_public_path__ + "img/yesVideo.9607ac6f.png";